<template>
  <div id="app">
    <!-- 根据路由元信息决定是否显示头部组件 -->
    <Head v-if="!$route.meta.isLogin" :page="$route.fullPath"></Head>

    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />

    <!-- 音频标签：初始处于静音状态（解决浏览器自动播放限制） -->
    <audio ref="audioElement" autoplay muted>
      <source :src="audioSrc" type="audio/mpeg" />
      <embed :src="audioSrc" />
    </audio>

    <!-- 新订单弹框：当音频播放异常时显示，用户点击后触发播放 -->
    <div class="mask" v-if="playAudio">
      <div class="error-box">
        <h1>新订单提醒</h1>
        <h2>您有一条新的控房易订单需要处理，请注意查收！</h2>
        <div class="btn" @click="handleUserInteraction">我知道了</div>
      </div>
    </div>
  </div>
</template>

<script>
import Head from "@/components/Header";

export default {
  name: "App",
  components: {
    Head
  },
  data() {
    return {
      titleText: "您有新的控房易订单，请注意查收！", // 标题滚动的初始文本
      offset: 0, // 标题滚动的偏移量
      playAudio: false, // 用于控制弹框显示，true 时提示用户触发音频播放
      timer: null, // 存放标题滚动定时器
      // 使用 require 引入音频文件，确保打包后路径正确
      audioSrc: require('@/assets/audio.mp3'),
      pollingEnabled:true
    };
  },
  mounted() {
    // 开始轮询通知接口
    // 初始化时判断当前路由
    if (this.$route.fullPath === '/'||this.$route.fullPath === '/login') {
      this.pollingEnabled = false;
    } else {
      this.pollingEnabled = true;
      this.pollNotifications();
    }
    var that = this
    document.addEventListener('click', function handler(event) {
      try {
        const audioElement = that.$refs.audioElement;
        // 静音播放
        audioElement.muted = true;
        const playPromise = audioElement.play();
      } catch (error) {
        console.error("播放音频时出错:", error);
      }
      document.removeEventListener('click', handler);
    });
    document.onmousemove = function(event) {
      if(that.$route.path === "/order"&&document.title != "控房易-深圳市港捷旅国际旅行社有限公司"){
        that.clearTitleScroll()
      }
      // 执行鼠标移动时的逻辑操作
    };

    // 当页面可见性发生变化时，如果当前路由为 '/order' 则清除标题滚动定时器
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible" && this.$route.path === "/order") {
        this.clearTitleScroll();
      }
    });
  },
  watch: {
    "$route"(to) {
      if (to.fullPath === "/order") {
        this.clearTitleScroll();
      }
      if (to.fullPath === "/"||to.fullPath === "/login") {
        this.pollingEnabled = false; // ⬅️ 停止轮询
      } else if(to.fullPath === "/hotelJoin"||to.fullPath === "/about"||to.fullPath === "/contactUs"||to.fullPath === "/recrult") {
        return  // ⬅️ 不做改动
      }else{
        if(!this.pollingEnabled){
          this.pollingEnabled = true;  // ⬅️ 恢复轮询
          this.pollNotifications(); 
        }
      }
    }
  },
  methods: {
    /**
     * 用户点击弹框时触发：
     * 1. 隐藏弹框
     * 2. 触发音频播放
     */
    handleUserInteraction() {
      this.playAudio = false;
      this.startAudioPlayback();
    },

    /**
     * 尝试播放音频：
     * 先取消静音（需用户交互后才有效），然后调用 play()
     */
    async startAudioPlayback() {
      try {
        const audioElement = this.$refs.audioElement;
        // 取消静音
        audioElement.muted = false;
        const playPromise = audioElement.play();
        if (playPromise !== undefined) {
          await playPromise;
        }
      } catch (error) {
        // 播放失败时显示弹框，提示用户点击触发
        this.playAudio = true;
        console.error("播放音频时出错:", error);
      }
    },

    /**
     * 开启标题滚动效果
     */
    startTitleScroll() {
      // 如果已有定时器，先清除
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(this.updateTitle, 200);
    },

    /**
     * 根据 offset 更新页面标题，达到动态滚动的效果
     */
    updateTitle() {
      // 拼接新标题文本（循环滚动效果）
      const newTitle =
        this.titleText.substring(this.offset) +
        " " +
        this.titleText.substring(0, this.offset);
      document.title = newTitle;
      this.offset++;
      if (this.offset % 2 === 0) {
        document.title = "【新订单通知】";
      }
      if (this.offset > this.titleText.length + 2) {
        this.offset = 0;
      }
    },

    /**
     * 清除标题滚动定时器，并将标题还原为固定文本
     */
    clearTitleScroll() {
      document.title = "控房易-深圳市港捷旅国际旅行社有限公司";
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    /**
     * 轮询通知接口
     * 改用 setTimeout 实现轮询，避免无限递归
     */
    pollNotifications() {
      
      if (!this.pollingEnabled) return;
      this.$http
        .get(this.Api.notifications, { params: {} }, { emulateJSON: true })
        .then(response => {
          if (response.status === 200) {
            // 收到新订单时：启动标题滚动及尝试自动播放音频
            this.startTitleScroll();
            this.startAudioPlayback();
          }
          // 根据业务需要对其他状态码（如 204）做处理
          // 5 秒后继续轮询
          setTimeout(this.pollNotifications, 5000);
        })
        .catch(error => {
          console.error("通知接口请求出错:", error);
          // 请求出错时 5 秒后继续轮询
          setTimeout(this.pollNotifications, 5000);
        });
    }
  },
  beforeDestroy() {
    // 清除标题滚动定时器，避免内存泄漏
    this.clearTitleScroll();
  },
  beforeCreate() {
    // 获取存储的认证信息，并设置 HTTP 头部
    let res = null;
    try {
      res = JSON.parse(this.dao.get("res"));
    } catch (e) {
      console.error("解析认证信息失败:", e);
    }
    if (res) {
      this.setHttpHeaders(res.access_token);
    } else {
      // 没有认证信息则跳转到登录页
      this.$router.push("/");
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/App.vue